import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Grid } from "@mui/material";
import DataPointWidget from "components/LH/HC/Panchangaya";
import { Divider } from "@mui/material";

function HCViewOther({ data }) {

    return (
            <MDBox pt={0} pb={1} >
                <MDBox mb={1}>
                    <Card>
                        {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                            <MDTypography variant="h5" fontWeight="medium">
                            අමතර
                            </MDTypography>
                        <Divider  variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                        </MDBox> */}
                        <Grid container mt={1} ml={0} pl={1} spacing={4}>
                    {data.map((item, index) => (
                        <Grid key={"s3"+index} item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6} md={4} lg={3}>
                            <DataPointWidget name={item.name} value={item.value} />
                        </Grid>
                    ))}
                </Grid>
                    </Card>
                </MDBox>
            </MDBox>
    );
};

HCViewOther.propTypes = {
    data: PropTypes.array,
  };

export default HCViewOther;